import React from 'react';
import t from '@jetshop/intl';
import { styled } from 'linaria/react';
import { css } from 'linaria';
import { Button } from '../ui/Button';
import ModalTrigger from '../ui/ModalTrigger';
import Configurator from './Configurator';
import { theme } from '../Theme';
import { Link } from 'react-router-dom';

const Container = styled('section')`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 0;

  ${theme.below.sm} {
    flex-direction: column;

    > * {
      width: 100% !important;

      + * {
        margin-top: 0.5rem;
      }
    }
  }

  p {
    /* flex: 1; */
    font-size: 0.875rem;
    line-height: 1.25;

    ${theme.below.sm} {
      font-size: 13px;
    }
  }

  button {
    background: ${theme.colors.black};
    width: 49%;
    text-transform: uppercase;
    border-radius: 50px;
  }
`;

const ExternalLink = styled('a')`
  width: fit-content;
  white-space: nowrap;
  min-width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${theme.colors.black};
  padding: 0 1rem;
  text-transform: uppercase;
  height: 46px;
  font-size: 14px;
  font-weight: 700;
  font-family: ${theme.fonts.primary};
  color: ${theme.colors.white};
  text-decoration: none;
  border-radius: 50px;
`;

const modalStyles = css`
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  position: absolute;
  background: white;
  padding: 1rem;
  outline: none;
`;

export const LinkStudio3D = () => {
  return (
    <Container className="link-studio-3d">
      <p>
        {t(
          'Den här produkten kan du enkelt designa så att den passar ditt hem. Du byter enkelt storlek, färg, tyg och ben.'
        )}
      </p>
      <ExternalLink as={Link} to="/vardagsrum/designa-din-soffa">
        {t('ÄNDRA DESIGN (3D)')}
      </ExternalLink>
    </Container>
  );
};

const ConfiguratorLink = ({ newConfig }) => {
  return (
    <Container>
      {newConfig ? (
        <p>
          {t(
            'Den här produkten kan du enkelt designa själv. Kontakta närmsta butik för att beställa.'
          )}
        </p>
      ) : (
        <p>{t('Design this product in our 3D tool')}</p>
      )}

      {newConfig ? (
        <>
          <ExternalLink
            href="https://troels.vividworks.com/VividWeb?lan=sv&h1=0266FD7F-C95F-43CD-BE82-31FE3AB70E67&lo=mobelmastarna"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('Design yourself')}
          </ExternalLink>
        </>
      ) : (
        <ModalTrigger
          modalStyles={modalStyles}
          target={(props) => <Configurator {...props} />}
        >
          {({ showTarget }) => (
            <Button onClick={showTarget}>{t('Design yourself')}</Button>
          )}
        </ModalTrigger>
      )}
    </Container>
  );
};

export default ConfiguratorLink;
